/* eslint-disable @typescript-eslint/naming-convention */
/* eslint-disable camelcase */
/* eslint-disable no-underscore-dangle */
import React, { useContext, useEffect, useState } from 'react';
import {
  HaierCostingContext,
  ParcelCostingDetailType,
} from 'views/Costing/common/context/HaierCostingContext';
import { Spin } from 'shared/components';
import { axiosErp } from 'shared/config/axios';
import { getStoredAuthToken } from 'shared/utils/authToken';
import Header from './Header';
import CostingDetail from './CostingDetail';

type ModalCostingDetailProps = {
  costingId: string;
  backUrl: string;
};

const ModalHaierCostingDetail: React.FC<ModalCostingDetailProps> = (props) => {
  const { costingId, backUrl } = props;
  const token = getStoredAuthToken();
  const { selectedCostingDetail, setSelectedCostingDetail } = useContext(HaierCostingContext);
  const { isLoading } = selectedCostingDetail!;
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const [data, setDataCosting] = useState<any>(null);

  const functionGetData = async () => {
    setLoading(true);
    try {
      const costingData = await axiosErp(token).get(`/costing-job/${costingId}`);
      setDataCosting(costingData.data);
    } catch (e) {
      setError(e);
      console.error('ERROR TO LOAD COSTING DETAIL: ', e);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (costingId) {
      functionGetData();
      setSelectedCostingDetail!(
        (prevState): ParcelCostingDetailType => ({
          ...prevState,
          costingId,
          backUrl,
        }),
      );
    }
  }, [costingId, setSelectedCostingDetail, backUrl]);

  useEffect(() => {
    if (!loading && !error && data) {
      const {
        costingStatus,
        costingNumber,
        totalAfterDiscount,
        jobNumber,
        edit_request_status,
        grandTotal,
      } = data;

      setSelectedCostingDetail!(
        (prevState): ParcelCostingDetailType => ({
          ...prevState,
          costingStatus,
          costingNumber,
          isLoading: false,
          modalConfirmChecked: {
            refNumber: jobNumber,
            costingNumber,
            totalAfterDiscount: totalAfterDiscount.cost,
            totalAfterDiscountSale: totalAfterDiscount.sale,
          },
          modalConfirmReject: {
            costingNumber,
            grandTotalPrice: grandTotal.cost,
            grandTotalPriceSale: grandTotal.sale,
          },
          editRequest: edit_request_status,
        }),
      );
    }

    return () => {
      setSelectedCostingDetail!(
        (prevState): ParcelCostingDetailType => ({
          ...prevState,
          isLoading: true,
        }),
      );
    };
  }, [costingId, data, error, loading, setSelectedCostingDetail]);

  return (
    <Spin spinning={isLoading}>
      <Header />
      <CostingDetail costingId={costingId} />
    </Spin>
  );
};

export default ModalHaierCostingDetail;
